import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { equals } from 'ramda';
import { IBindingCallback1, IBindingAction } from '../../../../common/models/callback';
import { IAppState } from '../../../../common/models/store/IAppState';
import { changeMessageTextRoutine } from '../../routines';
import RegularButton from '../../../../components/RegularButton';
import EmailTextArea from '../../../../components/EmailTextArea';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg';
import { IEmailTemplate } from '../../../../common/models/email/IEmailTemplate';
import { EmailType } from '../../../../common/enums/EmailType';
import { refEmailFooter, refEmailHeader } from '../../../../common/helpers/emailHelper';
import styles from './styles.module.scss';

interface IProps {
  emailTemplate: IEmailTemplate;
  onHide: IBindingAction;
  changeMessageText: IBindingCallback1<string>;
}

const MessagePreview: FunctionComponent<IProps> = ({ emailTemplate, changeMessageText, onHide }) => {
  const [message, setMessage] = useState(emailTemplate.body);
  const isDisabled = equals(emailTemplate.body, message.trim()) || !message.trim();

  const onSave = () => {
    changeMessageText(message);
    onHide();
  };

  const footer = emailTemplate.type === EmailType.CandidateRefRequest
    ? <FormattedMessage id="emailPreview.candidateLink" defaultMessage="<link to provide references>" />
    : refEmailFooter;

  const header = emailTemplate.type === EmailType.CandidateRefRequest
    ? <FormattedMessage id="emailPreview.firstName" defaultMessage="<Candidate first name>" />
    : refEmailHeader;

  return (
    <div className={styles.preview}>
      <header className={styles.previewHeader}>
        <div className={styles.previewTitle}>
          <FormattedMessage id="messagePreview.title" defaultMessage="Customize email to candidate" />
        </div>
        <div className="secondary-text">
          <FormattedMessage
            id="messagePreview.tip"
            defaultMessage="You can change your default message in your KodiakHR settings"
          />
        </div>
      </header>
      <main className={styles.previewBody}>
        <EmailTextArea
          message={message}
          onChange={setMessage}
          customEmailFooter={footer}
          customEmailHeader={header}
        />
      </main>
      <footer className={styles.previewFooter}>
        <RegularButton
          variant="tertiary"
          textIntlId="cancel"
          defaultMessage="Cancel"
          onClick={onHide}
        />
        <RegularButton
          disabled={isDisabled}
          variant="primary"
          textIntlId="saveEmail"
          defaultMessage="Save email"
          onClick={onSave}
          icon={<CheckIcon />}
        />
      </footer>
    </div>
  );
};

const mapStateToProps = ({
  requestBuilder: { emailTemplate }
}: IAppState) => ({ emailTemplate: (emailTemplate as IEmailTemplate) });

const mapDispachToProps = {
  changeMessageText: changeMessageTextRoutine
};

export default connect(mapStateToProps, mapDispachToProps)(MessagePreview);
